import * as Yup from 'yup';
import { zipcode } from '../../../../schemas';

const schema = Yup.object({
  zipcode,
});

export default schema;
